import React, { createContext, useContext, useState } from 'react';
import en from './en';
import es from './es';

type Locale = 'en' | 'es';

const dictionaries: Record<Locale, Record<string, string>> = { en, es };

interface LocaleContextValue {
  locale: Locale;
  setLocale: (l: Locale) => void;
  t: (key: string) => string;
}

const LocaleContext = createContext<LocaleContextValue>({
  locale: 'es',
  setLocale: () => {},
  t: (k) => k,
});

export function LocaleProvider({ children }: { children: React.ReactNode }) {
  const [locale, setLocale] = useState<Locale>(
    () => (localStorage.getItem('locale') as Locale | null) ?? 'es',
  );

  const t = (key: string): string => dictionaries[locale][key] ?? key;

  const handleSetLocale = (l: Locale) => {
    localStorage.setItem('locale', l);
    setLocale(l);
  };

  return React.createElement(
    LocaleContext.Provider,
    { value: { locale, t, setLocale: handleSetLocale } },
    children,
  );
}

export function useT(): (key: string) => string {
  return useContext(LocaleContext).t;
}

export function useLocale(): LocaleContextValue {
  return useContext(LocaleContext);
}
